/**
 *
 * @param {Object} e Error object from stax when tokenization fails
 * @param {string} e.code
 * @param {string} e.field
 * @param {string} e.key
 * @param {string} e.message
 *
 */
export const getErrorMessageType = (e) => {
  const { code, field, key, message } = e;

  // card invalid year
  if (field === "year" && key === "errors.invalid") {
    return "invalid_year";
  }

  // missing last name
  if (field === 'last_name' && key === 'errors.blank') {
    return 'empty_name'
  }

  // ach person_name
  if (
    e?.person_name &&
    e?.person_name[0] === "The person name field is required."
  ) {
    return "stax_ach_person_name";
  }

  // Routing number error from stax: { errors: ['Could not tokenize payment method: Routing number is invalid'] }
  if (e?.errors?.[0]?.match(/Routing number is invalid/gi)) {
    return "invalid_routing_number";
  }

  // Invalid Credit card
  if (e?.message?.match(/Credit card number entered is not valid/gi)) {
    return "invalid_card_number";
  }

  return "generic_stax_tokenization_error";
};
